import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    viewType: 'row',
    search: '',
    filters: {
        type: [],
        cycle: [],
        biotype: [],
        weatherSeason: [],
    },
};

export default createReducer(initial, {
    [actions.reset]: (state) => ({ ...initial, viewType: state.viewType }),
    [actions.setViewType]: (state, action) => ({ ...state, viewType: action.payload }),
    [actions.setFilter]: (state, { payload: { group, value } }) => ({
        ...state,
        filters: {
            ...state.filters,
            [group]: state.filters?.[group]?.includes(value)
                ? state.filters?.[group]?.filter((v) => v !== value)
                : [...state.filters[group], value],
        },
    }),
    [actions.setSearch]: (state, action) => ({ ...state, search: action.payload }),
});
